
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.143 15.143h29.714C39.488 15.143 40 14.63 40 14v-2.857c0-.631-.512-1.143-1.143-1.143H9.143C8.512 10 8 10.512 8 11.143V14c0 .631.512 1.143 1.143 1.143zm0 11.428h29.714c.631 0 1.143-.511 1.143-1.142V22.57c0-.63-.512-1.142-1.143-1.142H9.143A1.144 1.144 0 008 22.57v2.858c0 .63.512 1.142 1.143 1.142zm0 11.429h29.714c.631 0 1.143-.512 1.143-1.143V34c0-.631-.512-1.143-1.143-1.143H9.143C8.512 32.857 8 33.37 8 34v2.857C8 37.488 8.512 38 9.143 38z","fill":"#535353"}})])
          )
        }
      }
    